import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

export const CookiesStore = signalStore(
  { providedIn: 'root' },
  withState({
    cookieDialogVisiblity: localStorage.getItem('REVE-cookies') === null || localStorage.getItem('REVE-cookies') === 'false',
    cookieAccepted: localStorage.getItem('REVE-cookies') === 'true',

  }),
  withMethods((store) => ({
    setCookieDialogVisiblity: (visible: boolean) => { 
        patchState(store, {cookieDialogVisiblity: visible });
    },
    setCookie: (accepted: boolean) => {        
      patchState(store, { cookieAccepted: accepted });
    },
  }))
);
